import type { AppThemeContextProps } from '../AppThemeProvider/AppTheme';
import type { TooltipProps } from '@mui/material/Tooltip';

import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';

import { AppThemeContext } from '../AppThemeProvider/AppTheme';

import { appInfo } from '@egr/xbox/app-api/AppInfo';

export const TooltipWrapper: React.FC<TooltipProps & { childDisabled?: boolean }> = React.memo(
    (props: TooltipProps & { childDisabled?: boolean }) => {
        const themeContext: AppThemeContextProps = React.useContext(AppThemeContext);

        const { children, childDisabled, title, ...thisProps } = props;

        if (
            title !== null && title !== '' &&
            !themeContext.disableMuiTooltips &&
            (appInfo == null)
        ) {
            if (childDisabled) {
                return <Tooltip {...thisProps} title={title}><span>{children}</span></Tooltip>;
            }
            return <Tooltip {...thisProps} title={title}>{children}</Tooltip>;
        }

        return children;
    }
);

TooltipWrapper.displayName = 'TooltipWrapper';